module.exports = __webpack_public_path__ + "public/Icons/hello.png?ed754c8f";